import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import Popper from 'popper.js';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { BooleanConverter, InputConverter, NumberConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-lat-long-select',
    styleUrls: ['../../sharedStyles/base.scss', './lat-long-select.component.scss'],
    templateUrl: './lat-long-select.component.html'
})
export class LatLongSelectComponent extends BaseComponent implements AfterViewInit {
    @ViewChild('latLongSelectToggle') private readonly latLongSelectToggleRef: ElementRef<HTMLDivElement>;
    @ViewChild('latLongSelectContainer') private readonly latLongSelectContainerRef: ElementRef<HTMLDivElement>;

    private latLongSelectPopperRef: Popper;

    @Input() @InputConverter(BooleanConverter)
    get showLatLongSelect() { return this._showLatLongSelect; }
    set showLatLongSelect(value) {
        this._showLatLongSelect = value;
        this._showLatLongSelect ? this.onShow() : this.onHide();
    }
    private _showLatLongSelect: boolean;

    @Input() @InputConverter(NumberConverter) lat: number;
    @Input() @InputConverter(NumberConverter) long: number;

    @Output() readonly latChange: EventEmitter<number> = new EventEmitter();
    @Output() readonly longChange: EventEmitter<number> = new EventEmitter();

    private readonly latChangeSubject: Subject<number> = new Subject();
    private readonly longChangeSubject: Subject<number> = new Subject();

    @Input() @InputConverter(NumberConverter) debounceTime: number = 500;

    constructor(_vcr: ViewContainerRef) { super(_vcr, true); }

    ngAfterViewInit() {
        this.latLongSelectPopperRef = new Popper(this.latLongSelectToggleRef.nativeElement,
            this.latLongSelectContainerRef.nativeElement,
            {
                placement: 'bottom-end',
                positionFixed: true
            });

        this.latChangeSubject.pipe(
            debounceTime(this.debounceTime),
            distinctUntilChanged()
        ).subscribe(lat => this.latChange.emit(lat));

        this.longChangeSubject.pipe(
            debounceTime(this.debounceTime),
            distinctUntilChanged()
        ).subscribe(long => this.longChange.emit(long));
    }

    private onShow() {
        this.latLongSelectPopperRef.update();
        window.addEventListener('mousedown', this.outsideClickHandler);
        window.addEventListener('dragstart', this.outsideClickHandler);
        this.latLongSelectToggleRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
        this.latLongSelectContainerRef.nativeElement.addEventListener('mousedown', this.insideClickHandler);
    }

    private onHide() {
        window.removeEventListener('mousedown', this.outsideClickHandler);
        window.removeEventListener('dragstart', this.outsideClickHandler);
        this.latLongSelectToggleRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
        this.latLongSelectContainerRef.nativeElement.removeEventListener('mousedown', this.insideClickHandler);
    }

    private readonly outsideClickHandler = () => {
        this.showLatLongSelect = false;
    }

    private readonly insideClickHandler = (e: MouseEvent) => {
        e.stopPropagation();
    }

    onLatChange(lat) {
        this.lat = lat;
        this.latChangeSubject.next(lat);
    }

    onLongChange(long) {
        this.long = long;
        this.longChangeSubject.next(long);
    }
}
